/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ActionArea = (typeof ActionArea)[keyof typeof ActionArea];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionArea = {
  EXECUTION: "EXECUTION",
  READINESS: "READINESS",
  QUALITY: "QUALITY",
  DEPENDENCIES: "DEPENDENCIES",
} as const;
